'use client';

import type { FC } from 'react';
import { RulesSheet } from '../../RulesSheet';
import { FaTrophy, FaClock, FaDice, IoTicket } from '../../icons';
import { useLocalTranslation } from '../../../hooks/useLocalTranslation';
import translations from './raffle.translations';

interface RaffleRulesSheetProps {
  isOpen: boolean;
  onClose: () => void;
}

export const RaffleRulesSheet: FC<RaffleRulesSheetProps> = ({ isOpen, onClose }) => {
  const { t } = useLocalTranslation(translations);

  const accruals: { labelKey: 'ruleRowWin' | 'ruleRowMvp' | 'ruleRowTriple' | 'ruleRowQuad' | 'ruleRowAce' | 'ruleRowOneHp' | 'ruleRowClutch2' | 'ruleRowClutch3'; value: number }[] = [
    { labelKey: 'ruleRowWin', value: 1 },
    { labelKey: 'ruleRowMvp', value: 1 },
    { labelKey: 'ruleRowTriple', value: 1 },
    { labelKey: 'ruleRowQuad', value: 2 },
    { labelKey: 'ruleRowAce', value: 4 },
    { labelKey: 'ruleRowOneHp', value: 2 },
    { labelKey: 'ruleRowClutch2', value: 2 },
    { labelKey: 'ruleRowClutch3', value: 3 },
  ];

  return (
    <RulesSheet
      isOpen={isOpen}
      onClose={onClose}
      title={t('rulesTitle')}
      intro={
        <div className="overflow-hidden rounded-2xl bg-fill-tertiary">
          {accruals.map((row, i) => (
            <div
              key={row.labelKey}
              className={`flex items-center justify-between px-4 py-3 ${i > 0 ? 'border-t border-white/5' : ''}`}
            >
              <span className="text-sm text-label-primary">{t(row.labelKey)}</span>
              <span className="inline-flex items-center gap-1 text-sm font-bold text-accent-blue">
                +{row.value} <IoTicket size={13} />
              </span>
            </div>
          ))}
        </div>
      }
      rows={[
        { icon: <FaTrophy />, title: t('ruleWinsOnlyTitle'), body: t('ruleWinsOnlyDescription') },
        { icon: <FaClock />, title: t('ruleBurnTitle'), body: t('ruleBurnDescription') },
        { icon: <FaDice />, title: t('ruleOneChanceTitle'), body: t('ruleOneChanceDescription') },
      ]}
    />
  );
};

export default RaffleRulesSheet;
